var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderConstructions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 510.15 359.76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 429.36,
    x2: 432.77,
    y1: 225.03,
    y2: 273.94
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 213.3,
    x2: 217.12,
    xlinkHref: "#a",
    y1: 280.85,
    y2: 335.08
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 160.76,
    x2: 263.86,
    y1: 309.98,
    y2: 289.64
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#010101",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 231.52,
    x2: 334.62,
    xlinkHref: "#c",
    y1: 309.98,
    y2: 289.64
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 241.94,
    x2: 952.31,
    xlinkHref: "#a",
    y1: 197.22,
    y2: 160.28
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 201.21,
    x2: 294.38,
    xlinkHref: "#a",
    y1: 195.59,
    y2: 190.74
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 140.18,
    x2: 562.54,
    xlinkHref: "#a",
    y1: 199.67,
    y2: 99.67
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 142.97,
    x2: 563.47,
    xlinkHref: "#a",
    y1: 198.61,
    y2: 99.05
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 360.86,
    x2: 515.31,
    xlinkHref: "#a",
    y1: 217.84,
    y2: 353.38
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 353.28,
    x2: 368.97,
    y1: 227.41,
    y2: 227.41
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ead4d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e9cb"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 6.56,
    x2: 1891.15,
    xlinkHref: "#a",
    y1: 170.6,
    y2: 72.59
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(-1 0 0 1 -157.58 0)",
    x1: -597.66,
    x2: -578.4,
    xlinkHref: "#j",
    y1: 226.59,
    y2: 226.59
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 426.9,
    x2: 441.17,
    xlinkHref: "#a",
    y1: 207.42,
    y2: 225.32
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 429.31,
    x2: 464.72,
    xlinkHref: "#a",
    y1: 203.21,
    y2: 247.62
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 429.46,
    x2: 455.91,
    xlinkHref: "#a",
    y1: 203.41,
    y2: 236.58
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 428.66,
    x2: 358.06,
    xlinkHref: "#a",
    y1: 214.36,
    y2: 244.79
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientTransform: "matrix(-1 0 0 1 -157.58 0)",
    x1: -592.58,
    x2: -583.59,
    xlinkHref: "#j",
    y1: 272.4,
    y2: 272.4
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 426.36,
    x2: 444.16,
    xlinkHref: "#a",
    y1: 328.05,
    y2: 190.58
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 105.96,
    x2: 457.71,
    xlinkHref: "#a",
    y1: 81.66,
    y2: -1.63
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 106.62,
    x2: 454.37,
    xlinkHref: "#a",
    y1: 83.83,
    y2: 1.49
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 107.9,
    x2: 108.73,
    xlinkHref: "#a",
    y1: 161.11,
    y2: 496.51
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 108.1,
    x2: 108.93,
    xlinkHref: "#a",
    y1: 35.91,
    y2: 371.29
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 77.22,
    x2: 155.26,
    xlinkHref: "#a",
    y1: 73.44,
    y2: 54.96
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 77.71,
    x2: 152.81,
    xlinkHref: "#a",
    y1: 75.03,
    y2: 57.25
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 122.05,
    x2: 61.88,
    xlinkHref: "#a",
    y1: 354.33,
    y2: 381.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m451.19 387.71c-39.79 20.46-85.8 19.5-129.87 18.15l-153-4.79c-14.9-.45-29.92-.93-44.7-2.89a175 175 0 0 1 -25.56-5.18c-3.22-.93-6.38-1.95-9.54-3.13-1.63-.6-3.22-1.23-4.82-1.92a128.91 128.91 0 0 1 -25.37-14.3 142.44 142.44 0 0 1 -47.4-59.5c-8.88-20.89-12.93-45.45-5.21-66.88 14.28-39.67 59.28-52.01 94.54-71.36 33.23-18.24 61.1-47 80-81.56 21.82-39.88 23.92-50.12 71.36-47.17 44.84 2.77 92.49 6.6 128.69 35.19 20.69 16.28 35.69 39.31 50.36 61.88q28.62 44.06 57.24 88.15c8.25 12.7 16.62 25.68 20.86 40.45 13 45.33-17.77 94.39-57.58 114.86z",
    fill: "#68e1fd",
    opacity: 0.24,
    transform: "translate(-1.64 -46.71)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.51,
    cy: 335.87,
    fill: "#68e1fd",
    opacity: 0.24,
    rx: 156.49,
    ry: 13.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m81.24 65.4 20.17-8.33 110.91 10.4v10.55l-131.08.39z",
    fill: "#68e1fd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m98.05 53.8h19.85v275.75h-19.85z",
    fill: "#68e1fd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m439.55 234.86s12.84 6.63 13.05 11.6 3.31 26.5 3.31 26.5l-8.7 3.73 1.19 17.59a4.07 4.07 0 0 1 -3.67 4.34c-8.15.8-30.07-2-29.84-4.49 2.8-30-1.34-52 4-55.12s12.59-4.11 12.59-4.11z",
    fill: "#68e1fd",
    transform: "translate(-1.64 -46.71)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m445.57 229.98-11.98 1.6-1.55-2.02-18.09 2.02.23 1.71 18.01.77 3.89 3.42 9.78-1.09z",
    fill: "url(#a)",
    opacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m403 158.39v176.61a8.59 8.59 0 0 1 -8.6 8.6h-230.4a7.88 7.88 0 0 1 -8-9v-176.6c-.62-4.35 3.22-8.19 8-8.19h230.37a8.59 8.59 0 0 1 8.63 8.58z",
    fill: "#68e1fd",
    transform: "translate(-1.64 -46.71)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m161.86 287.85h104.52v9.04h-104.52z",
    fill: "url(#b)",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m243.21 287.01h9.89v69.56h-9.89z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m172.59 287.01h9.89v67.23h-9.89z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m172.66 323.73h9.96v-34.11h-10.17z",
    fill: "url(#c)",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m243.42 323.73h9.96v-34.11h-10.17z",
    fill: "url(#d)",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m301.14 129.77h86.96v124.22h-86.96z",
    fill: "url(#e)",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m291.21 129.77v124.24h-86.96v-8.73h49.07v-115.51z",
    fill: "url(#f)",
    opacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m166.36 121.08h86.96v124.2h-86.96z",
    fill: "url(#g)",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m168.85 121.18h86.96v122.03h-86.96z",
    fill: "url(#h)",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.64 -46.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m353.57 223.45s-1.57-.13-1.1.88 3.73 1.49 3.65 2c-1.4 8.77 6.21 10 9.47 9.16s37.19 18.82 37.19 18.82l.31-17.81z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.86 224.23c-3.28-.74-6.57-1.49-9.9-1.91a.77.77 0 0 0 -.45 0c-.38.19-.22.78.06 1.1 1 1.07 2.53 1.29 3.86 1.84a.46.46 0 0 1 .27.22.49.49 0 0 1 0 .29 6.47 6.47 0 0 0 -.27 3.26 4.11 4.11 0 0 0 1.77 2.69 6.3 6.3 0 0 0 2.81.72 7.64 7.64 0 0 0 3.43-.31 12.77 12.77 0 0 1 2-.86c.44-.09.95-.09 1.22-.44a1.21 1.21 0 0 0 .21-.62c.18-1.3.28-3.24-.74-4.22a8.9 8.9 0 0 0 -4.27-1.76z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403 158.39v4.24h-247.63v-4.24a8.59 8.59 0 0 1 8.61-8.6h230.39a8.59 8.59 0 0 1 8.63 8.6z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.21 219.76a3.83 3.83 0 0 0 -.38 1.14 5.77 5.77 0 0 0 .87 2.75c.95 2.23.81 5.16 2.79 6.55 1.1.77 2.55.79 3.8 1.27a5.52 5.52 0 0 1 3.23 3.43c.44 1.4-1.46 6.61-.09 7.13s3.59-1 4.89-1.94c1.55-1.08 2.95-2 3.1-3.53.53-5.42 1.05-10.91.23-16.3a13.77 13.77 0 0 0 -1.41-4.66 9 9 0 0 0 -6.83-4.52c-6.12-.63-8.12 4.01-10.2 8.68z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.73 210.92a3.76 3.76 0 0 0 .9 3.55c1.69 1.77 4.77 1.59 6.39 3.42a7.26 7.26 0 0 1 1.22 2.4c.2.55.57 1.2 1.15 1.12.79-.11.73-1.38 1.39-1.84a1.27 1.27 0 0 1 1.68.58c.74 1.26-.07 2.92-1.25 3.79-.09.06-.19.14-.18.25s.06.13.11.19l3.48 3.74a3.28 3.28 0 0 0 1.5 1.09c1.11.26 2.11-.66 2.88-1.5l3.43-3.77a9.26 9.26 0 0 0 1.53-2.06 8.86 8.86 0 0 0 .41-4.55 13.44 13.44 0 0 0 -1-4.68 9.77 9.77 0 0 0 -3.83-3.9c-4.69-2.85-10.45-3.29-15.93-3-1.39.08-.8 1.48-1.46 2.34-.78 1.09-2.01 1.36-2.42 2.83z",
    fill: "#606161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.57 211.68a9.53 9.53 0 0 0 .31 1.47c.12.2 23.1 8.43 23.1 8.43s1 .27 1.08-.28.35-1.43.35-1.43z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450 215.48a15.49 15.49 0 0 1 -.39 4s-1.33 1-5 .05-27-9.22-27-9.22-.35-1.42 1-1.55a5.62 5.62 0 0 0 2.87-1.54s4.89-10.81 18.17-5.78c8.63 3.23 10.27 9.81 10.35 14.04z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450 215.48a14 14 0 0 1 -.35 2.08 4.45 4.45 0 0 1 -2.91.44 10.92 10.92 0 0 1 -2-.36c-2.21-.57-11.52-3.79-18.62-6.26-3.26-1.15-6-2.16-7.41-2.65a5.62 5.62 0 0 0 2.87-1.54s4.89-10.81 18.17-5.78c8.53 3.26 10.17 9.84 10.25 14.07z",
    fill: "url(#n)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.74 218a10.92 10.92 0 0 1 -2-.36c-2.21-.57-11.52-3.79-18.62-6.26a.67.67 0 0 0 .13-.18s3.58-10.81 13.15-5.78c5.49 2.91 7.07 8.43 7.34 12.58z",
    fill: "url(#o)",
    opacity: 0.5
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m421.09 205.96-18.71 1.55 11.57 24.07 18.24-.57z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m420.6 206.68-18.22.83 11.57 24.07 18.24-.57z",
    fill: "url(#p)",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m427.46 268.31c-.41.06-.91.21-1 .62s.5.77 1 .9l1.81.5a4.7 4.7 0 0 0 -2.59-.29c-.27 0-.59.16-.65.43s.43.65.84.72l2.38.43a3.5 3.5 0 0 0 -2.36.29.58.58 0 0 0 -.26.23c-.13.29.26.53.57.61a18.3 18.3 0 0 0 2.64.49h-1.67a.84.84 0 0 0 -.58.15.6.6 0 0 0 .14.89 1.78 1.78 0 0 0 1 .22h1.4a2.47 2.47 0 0 1 .82.12c.78.33 1 1.4 1.76 1.79a1.58 1.58 0 0 0 1.92-.65 3.09 3.09 0 0 0 .31-2.16 5.83 5.83 0 0 0 -2.81-3.95c-1.65-1.02-2.62-1.65-4.67-1.34z",
    fill: "url(#q)",
    transform: "translate(-1.64 -46.71)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m446.09 250.06-5.9 40.99 7.14 47.52-4.66.62-13.97-44.72-1.87-21.12-16.14 63.66h-4.04l7.74-89.02z",
    fill: "#68e1fd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m446.09 250.06-5.9 40.99 7.14 47.52-4.66.62-13.97-44.72-1.87-21.12-16.14 63.66h-4.04l3.98-45.73 3.76-43.29z",
    fill: "url(#r)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m450.14 389.74c0 .12.06.26 0 .35a.42.42 0 0 1 -.29.11 52.68 52.68 0 0 1 -10.43 0 6.63 6.63 0 0 1 1.59-2.88 5.1 5.1 0 0 1 1.42-.85c1.38-.61 4.36-1.8 5.88-1.24 1.25.51 1.55 3.31 1.83 4.51z",
    fill: "#606161",
    transform: "translate(-1.64 -46.71)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m412.29 389.05a.43.43 0 0 1 -.12.31.48.48 0 0 1 -.31.1 67.23 67.23 0 0 1 -9.73 0 .51.51 0 0 1 -.3-.09c-.16-.15-.07-.41 0-.59a10.69 10.69 0 0 1 4.37-4.32c1.16-.59 4.2-1.67 5.43-.76s.8 3.99.66 5.35z",
    fill: "#606161",
    transform: "translate(-1.64 -46.71)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m391.75 229.53 38.2 5.59-13.51 15.88a13.4 13.4 0 0 0 -8.31-6.74l-40.34-11.26.31-7.45z",
    fill: "#68e1fd",
    transform: "translate(-1.64 -46.71)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m207.32 77.87h1.45v35.77h-1.45z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m168 167.79s35.73-17.8 87 0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.1,
    transform: "translate(-1.64 -46.71)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m212.32 67.47v10.55h-94.41v-20.74z",
    fill: "url(#s)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m212.32 72.13v5.89h-94.41v-16.08z",
    fill: "url(#t)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m98.05 53.8h19.85v275.75h-19.85z",
    fill: "url(#u)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m103 53.8h10.97v275.75h-10.97z",
    fill: "url(#v)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m98.05 58.6v19.81h-16.81v-13.01z",
    fill: "url(#w)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m98.05 62.02v16.39h-16.81v-9.6z",
    fill: "url(#x)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#68e1fd",
    height: 4.35,
    rx: 2.17,
    width: 55.49,
    x: 175.26,
    y: 128.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#68e1fd",
    height: 2.42,
    rx: 1.21,
    width: 30.82,
    x: 175.26,
    y: 136.77
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#68e1fd",
    height: 2.42,
    rx: 1.21,
    width: 30.82,
    x: 188.1,
    y: 142.78
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#68e1fd",
    height: 2.39,
    rx: 1.19,
    width: 4.52,
    x: 209.01,
    y: 136.77
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#68e1fd",
    height: 2.39,
    rx: 1.19,
    width: 4.52,
    x: 215.53,
    y: 136.77
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#68e1fd",
    height: 2.39,
    rx: 1.19,
    width: 4.52,
    x: 178.57,
    y: 142.78
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#68e1fd",
    height: 2.39,
    rx: 1.19,
    width: 4.52,
    x: 222.05,
    y: 136.77
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m164.4 262.52h82.2v12.48h-82.2z",
    fill: "#68e1fd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m162.28 293.01h100.42v26.27h-100.42z",
    fill: "#68e1fd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m162.65 338.66v27.34l101.89-.2-.62-27.13zm2.61 3.48h15.52l-15.07 20h-.45zm24.86 0h9.94l-14.91 20h-10zm19.28 0h9.95l-14.92 20h-9.79zm19.44 0h9.94l-15.06 20h-9.8zm19.29 0h9.94l-14.92 20h-9.79zm12.8 20h-8.28l8.28-11.14z",
    fill: "#fff",
    transform: "translate(-1.64 -46.71)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m119.49 348.88c-1.53 3.13-2.62 7-.78 10a40.86 40.86 0 0 0 3 3.34c4 4.88 1.89 12.22-1.24 17.67a10.73 10.73 0 0 0 -1.83 4.61c-.12 2.61 1.77 4.78 3.34 6.86s2.71 4.69 1.65 6.86a159.88 159.88 0 0 1 -35.09-8.31c-1.63-.6-3.22-1.23-4.82-1.92-.33-3.64.82-7.44 2.29-10.87 1.63-3.76 4.13-7.67 4.76-11.8.57-3.76-.09-7.28 1.08-11.07a25.06 25.06 0 0 1 15.15-16.25c2.11-.73 4.42-1.24 6-2.77a12 12 0 0 0 2.47-4q4.24-9.21 8.42-18.48c1.3-2.83 3-6 6.11-6.5 2.38-.39 4.76 1.18 5.93 3.28a11.74 11.74 0 0 1 1.06 7.05c-1.34 12.32-11.99 21.22-17.5 32.3z",
    fill: "#68e1fd",
    transform: "translate(-1.64 -46.71)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m119.49 348.88c-1.53 3.13-2.62 7-.78 10a40.86 40.86 0 0 0 3 3.34c4 4.88 1.89 12.22-1.24 17.67a10.73 10.73 0 0 0 -1.83 4.61c-.12 2.61 1.77 4.78 3.34 6.86s2.71 4.69 1.65 6.86a159.88 159.88 0 0 1 -35.09-8.31c-1.63-.6-3.22-1.23-4.82-1.92-.33-3.64.82-7.44 2.29-10.87 1.63-3.76 4.13-7.67 4.76-11.8.57-3.76-.09-7.28 1.08-11.07a25.06 25.06 0 0 1 15.15-16.25c2.11-.73 4.42-1.24 6-2.77a12 12 0 0 0 2.47-4q4.24-9.21 8.42-18.48c1.3-2.83 3-6 6.11-6.5 2.38-.39 4.76 1.18 5.93 3.28a11.74 11.74 0 0 1 1.06 7.05c-1.34 12.32-11.99 21.22-17.5 32.3z",
    fill: "url(#y)",
    opacity: 0.5,
    transform: "translate(-1.64 -46.71)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m103.42 384.79a10.83 10.83 0 0 1 -5.36 8.21c-3.22-.93-6.38-1.95-9.54-3.13-1.63-.6-3.22-1.23-4.82-1.92a128.91 128.91 0 0 1 -25.37-14.3 31.7 31.7 0 0 1 -1.2-4.69 8.28 8.28 0 0 1 3.64-8.28 30.41 30.41 0 0 0 3.85-2.2c2.68-2.2 2.71-6.38 1.36-9.54s-3.83-5.75-5.63-8.7-3-6.65-1.57-9.78c.94-2 2.83-3.46 4-5.39 2.22-3.61 1.5-8.24.69-12.4-1.08-5.65-2.17-11.28-3.28-16.94-.69-3.67-1.21-8 1.5-10.6 3.68-3.49 9.75-.69 13.4 2.8a33 33 0 0 1 9.3 14.69c3.43 12.31-2.56 26.16 2.25 38 3.22 8 10.78 13.46 14.54 21.19 3.41 7.06 3.35 15.33 2.24 22.98z",
    fill: "#68e1fd",
    transform: "translate(-1.64 -46.71)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstructions);
export default __webpack_public_path__ + "static/media/under-constructions.3c05782588a474edce8d75cee3651040.svg";
export { ForwardRef as ReactComponent };